module.exports = __webpack_public_path__ + "static/media/close.9f7069cd.svg";